var scope_0 = require('/opt/build/repo/apps/english/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1e1118cfb9f7ab693222dfb82a70adc5.js').default;
var scope_1 = require('/opt/build/repo/apps/english/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59a49a0dbe08e1db69b226c178cdf9f0.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    